export default function Tooltip({
  text,
  children,
  position = "top", // Defaulting to top
}: {
  text: string;
  children: React.ReactNode;
  position?: "top" | "right" | "bottom" | "left";
}) {
  // Mapping positions to Tailwind classes
  const positionClasses = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-4",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-4",
    left: "right-full top-1/2 -translate-y-1/2 mr-4",
    right: "left-full top-1/2 -translate-y-1/2 ml-4",
  };

  return (
    <div className="relative inline-flex items-center group/tooltip">
      <span
        className={`absolute z-10 hidden whitespace-nowrap rounded bg-grayscale-solid-elevate-level3 px-3 py-2 text-xs text-grayscale-solid-g10 shadow-lg group-hover/tooltip:block ${positionClasses[position]}`}
      >
        {text}
      </span>
      {children}
    </div>
  );
}
